import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';
import { Alerts } from '../../features/inventory/components/AlertsComponent';

export function AlertsCard() {
  return (
    <Card className={cn(
      "h-full",
      "bg-white/50 dark:bg-gray-900/50 backdrop-blur-sm",
      "transition-all duration-300 ease-out"
    )}>
      <CardContent className="p-6">
        <Alerts mode="all" />
      </CardContent>
    </Card>
  );
}
